angular
	.module 'App.Repository'

.factory 'BackgroundProcessRepository', ['$q', 'BaseRepository', '$window', 'CredentialsManager', ($q, BaseRepository, $window, CredentialsManager) ->
	class BackgroundProcessRepository extends BaseRepository
		@resource = '/background'
		@isRestricted = true

		getFileStatus: (typeId, format) ->
			@constructor.resource = '/background'
			@findById typeId, @getQuery(format)

		download: (typeId, format) ->
			query = @getQuery(format)

			CredentialsManager.injectAccessToken query

			$window.location.href = @toString(query, '/' + typeId + '/download')
			$q.when true

		startProcessing: (typeId, filter, format) ->
			originResource = @constructor.resource
			@constructor.resource += '/' + typeId
			@create {filter: filter, format: format}
				.then (response) =>
					@constructor.resource = originResource
					return response

		getQuery: (format) ->
			query = @createQuery()

			if angular.isDefined format
				query.addParameter 'format', format

			return query

	return new BackgroundProcessRepository
]
